<template>
  <svg-icon type="mdi" :path="path"></svg-icon>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiMonitorDashboard } from '@mdi/js';

export default {
  name: "IconDashboard",
  components: {
    SvgIcon
  },
  data() {
    return {
       path: mdiMonitorDashboard,
    }
  }
}
</script>